module.exports = __webpack_public_path__ + "img/infrastructure-5.315e302e.png";